export const TEXTAREA_MAX_CHARS = 2000
export const TEXTAREA_MIN_ROWS = 6
